import React from 'react';
import { CheckIcon, ChevronLeft, ChevronRight } from '../../Icons';
import StatusChip from '../StatusChip';
import { getInitials, getAvatarColor } from '../../utils';
import {
    leftPanel,
    tableWrapper,
    tableHeaderRow,
    tableHeaderCell,
    tableRow,
    tableRowSelected,
    radioCircle,
    radioCircleSelected,
    rowContent,
    opportunityTitle,
    actionBySection,
    avatarWrap,
    avatar,
    avatarName,
    noDataText,
    paginationFooter,
    paginationLeft,
    rowsPerPageLabel,
    rowsPerPageSelect,
    paginationInfo,
    paginationRight,
    paginationButton,
} from '../../RecentActivity.style';
import { headerCellTitle, headerCellAssignee } from './LeftPanel.style';

const LeftPanel = ({
    paginatedRows,
    selectedRowId,
    onRowClick,
    rowsPerPage,
    onRowsPerPageChange,
    currentPage,
    totalPages,
    totalCount,
    onPageChange,
    chipStyles,
    avatarColors,
}) => {
    const rangeStart = currentPage * rowsPerPage + 1;
    const rangeEnd = Math.min((currentPage + 1) * rowsPerPage, totalCount);

    return (
        <div style={leftPanel}>
            <div style={tableWrapper}>
                <div style={tableHeaderRow}>
                    <div style={{ ...tableHeaderCell, ...headerCellTitle }}>Opportunity Title</div>
                    <div style={{ ...tableHeaderCell, ...headerCellAssignee }}>Current Assignee</div>
                </div>

                {paginatedRows.length === 0 && (
                    <div style={noDataText}>No recent activity data available.</div>
                )}

                {paginatedRows.map((row) => {
                    const isSelected = selectedRowId === row.id;
                    return (
                        <div
                            key={row.id}
                            style={isSelected ? tableRowSelected : tableRow}
                            onClick={() => onRowClick(row.id)}
                        >
                            {isSelected ? (
                                <div style={radioCircleSelected}>
                                    <CheckIcon />
                                </div>
                            ) : (
                                <div style={radioCircle} />
                            )}

                            <div style={rowContent}>
                                <div style={opportunityTitle} title={row.title}>
                                    {row.title}
                                </div>
                                <div style={actionBySection}>
                                    <div style={avatarWrap}>
                                        <div
                                            style={{
                                                ...avatar,
                                                backgroundColor: getAvatarColor(row.actionBy, avatarColors),
                                            }}
                                        >
                                            {getInitials(row.actionBy)}
                                        </div>
                                        <span style={avatarName}>{row.actionBy}</span>
                                    </div>
                                    <StatusChip status={row.status} chipStyles={chipStyles} />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            <div style={paginationFooter}>
                <div style={paginationLeft}>
                    <span style={rowsPerPageLabel}>Rows per page</span>
                    <select style={rowsPerPageSelect} value={rowsPerPage} onChange={onRowsPerPageChange}>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                    </select>
                </div>
                <span style={paginationInfo}>
                    {totalCount > 0 ? `${rangeStart}–${rangeEnd} of ${totalCount}` : '0 of 0'}
                </span>
                <div style={paginationRight}>
                    <span style={paginationInfo}>
                        Page {totalPages > 0 ? currentPage + 1 : 0} of {totalPages}
                    </span>
                    <button
                        style={paginationButton}
                        onClick={() => onPageChange(Math.max(0, currentPage - 1))}
                        disabled={currentPage === 0}
                    >
                        <ChevronLeft />
                    </button>
                    <button
                        style={paginationButton}
                        onClick={() => onPageChange(Math.min(totalPages - 1, currentPage + 1))}
                        disabled={currentPage >= totalPages - 1}
                    >
                        <ChevronRight />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LeftPanel;
